import * as actionTypes from '../../actions/actionTypes';
import {cloneDeep} from "lodash";

const initialState = {
    certificateRequests: [],
    loadingCertificateRequests: false,
    certificatePlaces: [],
    loadingCertificatePlaces: false,

    waitingForSendCertificateRequestResult: false
};

////////////////////////////////////////////////////////////////

const loadCertificateRequests = (state) => {
    return {
        ...state,
        loadingCertificateRequests: true
    }
}

const setCertificateRequests = ( state, action ) => {
    let tmp = [...action.certificateRequests]
    return {
        ...state,
        certificateRequests: tmp,
        loadingCertificateRequests: false
    }
}

////////////////////////////////////////////////////////////////

const loadCertificatePlaces = (state) => {
    return {
        ...state,
        loadingCertificatePlaces: true
    }
}

const setCertificatePlaces = ( state, action ) => {
    let tmp = [...action.certificatePlaces];
    let result = [];

    //Для организации деревьев в react-select используются поля label и options
    for (let dto of tmp) {
        result.push({label: dto.type, options: dto.places})
    }

    return {
        ...state,
        certificatePlaces: result,
        loadingCertificatePlaces: false
    }
}

////////////////////////////////////////////////////////////////

const sendCertificateRequest = (state) => {
    return {
        ...state,
        waitingForSendCertificateRequestResult: true
    }
}

const receiveSendCertificateRequestResult = (state, action) => {
    let requests = state.certificateRequests;
    requests.unshift(action.newCertificateRequest);

    return {
        ...state,
        waitingForSendCertificateRequestResult: false,
        certificateRequests: requests
    }
}

////////////////////////////////////////////////////////////////

const updateCertificateRequest = ( state, action ) => {
    const certificateRequestsCopy = state.certificateRequests.map(m => {
        let certificateRequestCopy;
        if(m.id === action.certificateRequest.id){
            certificateRequestCopy = action.certificateRequest;
        } else {
            certificateRequestCopy = cloneDeep(m)
        }
        return certificateRequestCopy;
    })
    return {
        ...state,
        certificateRequests: certificateRequestsCopy,
    }
}

////////////////////////////////////////////////////////////////

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.LOAD_CERTIFICATE_REQUESTS: return loadCertificateRequests( state );
        case actionTypes.SET_CERTIFICATE_REQUESTS: return setCertificateRequests( state, action );

        case actionTypes.LOAD_CERTIFICATE_PLACES: return loadCertificatePlaces( state );
        case actionTypes.SET_CERTIFICATE_PLACES: return setCertificatePlaces( state, action );

        case actionTypes.SEND_CERTIFICATE_REQUEST: return sendCertificateRequest( state );
        case actionTypes.RECEIVE_SEND_CERTIFICATE_REQUEST_RESULT: return receiveSendCertificateRequestResult( state, action );
        case actionTypes.UPDATE_CERTIFICATE_REQUEST: return updateCertificateRequest( state, action );
        default: return state;
    }
};
export default reducer;